import {SET_LOADING_PAD} from "../types";

const setLoadingPad= (value) => async (dispatch) => {
    dispatch({type: SET_LOADING_PAD,payload:{signatureFiles:{loadingPad:value}}});
};


export default setLoadingPad;